import { triviaLeaderboardSchema } from "../../../lib";
import type { UseRequestQueryProps } from "../../../request";
import { useRequestQuery } from "../../../request";
import { useSession } from "../../../session";
import { keyLeaderboards } from "./keyTrivia";

type UseRequestTriviaLeaderboardsProps = UseRequestQueryProps & {
  communityId: number | "friends" | "all";
  apiVersion?: string;
};

export const useRequestTriviaLeaderboards = ({
  communityId,
  apiVersion = process.env.NEXT_PUBLIC_X_HALLOW_VERSION,
  ...props
}: UseRequestTriviaLeaderboardsProps) => {
  const { token } = useSession();

  return {
    query: useRequestQuery<typeof triviaLeaderboardSchema>({
      queryFnRequestProps: {
        urlBackendPath: `/me/communities/${communityId}/trivia-leaderboard`,
        requestType: "authenticated",
        headers: {
          "X-Hallow-Version": apiVersion,
          Authorization: `Bearer ${token}`,
        },
        schema: triviaLeaderboardSchema,
      },
      queryKey: keyLeaderboards({ communityId }),
      ...props,
    }),
  };
};
